<template>
<!-- <CompanyPolicy></CompanyPolicy> -->
<div class="col-xxl-12 mb-5">
    <!-- <ECShopAdvisory></ECShopAdvisory> -->
  </div>


  <div v-show="loading"> 
  <el-skeleton :rows="10" animated />
</div>
  <div class="col-xxl-12" v-show="!loading">
      <!--begin::Reorder History-->
    <div :class="widgetClasses" class="card">
      <!--begin::Header-->
      <div class="card-header border-0 pt-5 mb-5">
        <button
            type="button"
            class="btn btn-success px-2 py-2"
            v-on:click="registerNewEndorser()"
          >
          <span class="px-2">Encode BIBO Endorser</span>
          </button>
        
          <button type="button" ref="registerNewBiboButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_register_account_modal_bibo`"  >
        Click here
        </button>
        <RegisterEndorserModalBibo :key="modalkey" :slotdata="slotdata" >
        </RegisterEndorserModalBibo>
      </div>
      <!--end::Header-->

      <!--begin::Body-->
      <div class="card-body py-3">
        <!--begin::Table container-->
        <div class="table-responsive">
          <!--begin::Table-->
          <table class="table align-middle gs-0 gy-4">
            <!--begin::Table head-->
            <thead>
              <tr class="fw-bolder text-muted bg-light">
                <th class="ps-4 min-w-125px rounded-start">Ref. #</th>
                <th class="min-w-200px">User ID</th>
                <th class="min-w-225px">Name</th>
                <th class="min-w-200px">Sponsor</th>
                <th class="min-w-200px">Action</th>
              </tr>
            </thead>
            <!--end::Table head-->
            <!--begin::Table body-->
            <tbody>
              <template v-for="(item, index) in list" :key="index">
                <tr>
                  <td>&nbsp;&nbsp;&nbsp;{{item.recid}}</td>
                  <td>{{item.usid}}</td>
                  <td>{{item.usidname}}</td>
                  <td>{{item.spname}} ({{item.spid}})</td>
                  <td>

                      <button 
                        type="button"
                        class="btn btn-primary er fs-6 px-8 py-2"
                        data-bs-toggle="modal"
                        :data-bs-target="`#kt_modal_bibo_reposition`"
                        v-if="!isOverriden"
                      >
                      REPOSITION
                    </button>
                    <BIBO_REPOSITION_ENDORSER :key="index" :usid="item.usid"></BIBO_REPOSITION_ENDORSER>
                  </td>
                </tr>
              </template> 
            </tbody>
            <!--end::Table body-->
          </table>
          <!--end::Table-->


          

        </div>
        <!--end::Table container-->
      </div>
      <!--begin::Body-->
    </div>
  <!--end::Reorder History-->
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import pagination from 'vue-bootstrap-pagination'
import {getBiboEndorsersForRepositioning}  from "@/api/bibo";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from "@/views/ECShopAdvisory.vue";
import BIBO_REPOSITION_ENDORSER from "@/views/BIBO_REPOSITION_ENDORSER.vue";
import RegisterEndorserModalBibo from "@/views/auth/RegisterEndorserModalBibo.vue";

export default defineComponent({
  name: "reorder",
  components: {
    // CompanyPolicy,
    // ECShopAdvisory,
    BIBO_REPOSITION_ENDORSER,
    RegisterEndorserModalBibo
  },
  data() {
    return { 
      list : [],
      pagination: {
        total: 0,
        per_page: 10,    // required
        current_page: 1, // required
        last_page: 0,    // required
        from: 1,
        to: 12,
      },
       loading: true,
       slotdata : {},
      modalkey : 0,
    }
  },
  mounted(){
      this.reorderhistory();
      this.initSlotData();
  },
  methods : {
    async reorderhistory(){
      this.loading = true;
      const options = {
        params: {
          paginate: this.pagination.per_page,
          page: this.pagination.current_page,
          /* additional parameters */
        }
      };
      
      const response = await getBiboEndorsersForRepositioning(1);
      this.list = response.data.pageList;
      this.pagination = response.data.pagination;
      this.loading = false;
    },

    initSlotData() {
      var user = String(localStorage.getItem("ec_current_usid"));

      this.slotdata = {
          upid : user,
          spid : user,
          position : "L"
        };
      
      this.modalkey += 1;

    },
    registerNewEndorser(){
			    setTimeout(() => {    
					const btn = this.$refs.registerNewBiboButton as any;
					btn.click();
				}, 100);
		  } 
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("reorderTab") || "0");
      setCurrentPageTitle("BIBO Reposition");

    });
    
  }
});
</script>
